export const widgetNames = {
  "coins-winners-ticker": "Coins Winners Ticker",
  "ultimate-fan": "Ultimate Fan",
  "promo-carousel": "Promo Carousel",
  "mini-game-section-box": "Mini Game Section BOX",
  "mini-game-section-vert": "Mini Game Section Vert",
  "mini-game-section-big": "Mini Game Section Big Box",
  "mini-game-section-full": "Mini Game Section Full Box",
  "mini-game-section-feature": "Mini Game Section Feature",
  "prize-draw-active": "Prize Draw: Active",
  "prize-draw-winner": "Prize Draw: Winner",
  "hall-of-fame": "Hall of Fame",
  "advert-box": "Advert Box",
  "advert-half-box": "Advert Half Box",
  "advert-banner": "Advert Banner",
};
